import { useState } from 'react';
import { createStripeConnectLink } from '../services/stripe';

const useStripeConnectOnboarding = () => {
  const [isNoticeOpen, setIsNoticeOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const openNotice = () => setIsNoticeOpen(true);

  const closeNotice = () => {
    if (isLoading) return;
    setIsNoticeOpen(false);
  };

  const continueToStripe = async () => {
    setIsLoading(true);

    try {
      const url = await createStripeConnectLink(window.location.href);
      window.location.href = url;
    } catch (error) {
      console.error('Failed to create Stripe Connect link:', error);
      alert('There was a problem connecting to Stripe. Please try again.');
      setIsLoading(false);
      setIsNoticeOpen(false);
    }
  };

  return {
    isLoading,
    isNoticeOpen,
    openNotice,
    closeNotice,
    continueToStripe
  };
};

export default useStripeConnectOnboarding;
